export default function(color) {
  let cssColor = undefined;

  if (color.length === 3) {
    cssColor = `rgb(${color.join(',')})`;
  }
  else if (color.length === 4) {
    cssColor = `rgba(${color.join(',')})`;
  }

  return cssColor;
}



// WEBPACK FOOTER //
// ./src/core/cssColorFromArray.js